__turbopack_context__.v({
  "cEmailRender": "style-module-scss-module__PS6PNa__cEmailRender",
});
